<div class="history-header">
  <div class="history-title">{{ 'AI_ASSISTANT.SETTINGS.GENERATION_CHAT.HISTORY.TITLE' | translate }}</div>
  <button
    mat-icon-button
    type="button"
    class="new-chat-icon"
    [attr.aria-label]="'AI_ASSISTANT.SETTINGS.GENERATION_CHAT.HISTORY.NEW_CHAT' | translate"
    (click)="onNewChatClick()"
  >
    <mat-icon>add</mat-icon>
  </button>
  <button
    mat-icon-button
    type="button"
    class="close-icon"
    [attr.aria-label]="'AI_ASSISTANT.SETTINGS.GENERATION_CHAT.HISTORY.CLOSE_HISTORY' | translate"
    (click)="onCloseClick()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="history-list">
  @if (isEmpty()) {
    <div class="history-empty">{{ 'AI_ASSISTANT.SETTINGS.GENERATION_CHAT.HISTORY.EMPTY' | translate }}</div>
  }

  @if (!loading()) {
    @for (group of groupedSessions(); track group.label) {
      <div class="group-title">{{ group.label | translate }}</div>
      @for (session of group.sessions; track trackBySessionId($index, session)) {
        <button
          type="button"
          class="session-row"
          [class.active]="session.sessionId === activeSessionId()"
          (click)="onSessionClick(session.sessionId)"
        >
          <div class="active-indicator"></div>
          <div class="session-content">
            <div class="session-preview">
              {{
                previews()[session.sessionId] ||
                ('AI_ASSISTANT.SETTINGS.GENERATION_CHAT.HISTORY.NO_PREVIEW' | translate)
              }}
            </div>
          </div>
          <span class="session-timestamp">
          @if (session.updated || session.created) {
            {{ (session.updated || session.created) | date: 'shortDate' }}
          }
        </span>
        </button>
      }
    }
  }

  <glxy-infinite-scroll-trigger (isVisible)="loadMore()"></glxy-infinite-scroll-trigger>
  @if (loading()) {
    <glxy-loading-spinner></glxy-loading-spinner>
  }
</div>
